// Type definitions of the employee and its timetables
export interface EmployeeType {
    id: number;
    user: number;
    full_name: string | null;
    email: string | null;
    role_name: string | null;
    profile_picture: string | null;
    number: string | null;
    date_of_employment: string | null;
    cost_price: string | null;
    is_active: boolean;
}

export interface EmployeeTimeTableDayType {
    id?: number | null;
    week_number: 1 | 2;
    day_of_week: number;
    start_time: string | null;
    end_time: string | null;
    break_duration: number | string | null;
    total_hours: number | string | null;
}

export interface EmployeeTimeTableType {
    id: number;
    employee: number;
    start_date: string | null;
    end_date: string | null;
    has_second_week: boolean;
    week1_leave_hours_budget: number | string | null;
    week2_leave_hours_budget: number | string | null;
    days: EmployeeTimeTableDayType[];
    is_editable: boolean;
    deleted: boolean;
    created: string;
    modified: string;
}

// The weekdays of a timetable in display order
export const DAYS_OF_WEEK: { value: number; label: string }[] = [
    { value: 0, label: 'employee.timetable.monday_label' },
    { value: 1, label: 'employee.timetable.tuesday_label' },
    { value: 2, label: 'employee.timetable.wednesday_label' },
    { value: 3, label: 'employee.timetable.thursday_label' },
    { value: 4, label: 'employee.timetable.friday_label' },
    { value: 5, label: 'employee.timetable.saturday_label' },
    { value: 6, label: 'employee.timetable.sunday_label' },
];

// Creates the default (empty) day rows for a new timetable, for one or two weeks
export const createDefaultTimetableDays = (hasSecondWeek: boolean): EmployeeTimeTableDayType[] => {
    const weeks = hasSecondWeek ? [1, 2] : [1];

    return weeks.flatMap((weekNumber) =>
        DAYS_OF_WEEK.map((day) => ({
            id: null,
            week_number: weekNumber as 1 | 2,
            day_of_week: day.value,
            start_time: null,
            end_time: null,
            break_duration: null,
            total_hours: null,
        }))
    );
};
